export interface CmsRegistrationSummaryPanel {
  registrationSummaryPanelTitle: string;
  registrationSummaryPanelLegal: string;
}
